<cx-navigation-ui
  [node]="node$ | async"
  [flyout]="false"
  [ngClass]="styleClass$ | async"
></cx-navigation-ui>
